import gql from "graphql-tag";

const NAVSLOT_QUERY = gql`  
  query NavSlot($navSlotSlug: String!) {
    navigation(slug:$navSlotSlug){
    id
    name
    description
    slug
    menu{
      id
      name
      description
      items{
        id
        label
        description
        uri
      }
    }
  }
  }
`;

export default NAVSLOT_QUERY;